<!-- eslint-disable vue/multi-word-component-names -->
<script setup lang="ts">
import SiteSelectBase from '../../../sites/components/SiteSelectBase.vue'

definePage({
    meta: {
        requiresAuth: true,
        requiresOrganisation: false,
        hideHeader: true,
        hideLeftColumn: true,
        hideRightColumn: true,
    }
})
</script>

<template>
  <SiteSelectBase />
</template>